import "../fcopel/style.css";
import { Sectionpd} from "../../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "../padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Prestador() {
  return (
    <main>
        <Helmet>
            <title>Fcopel Prestador - Gabriel Barbosa</title>
            <meta name="description" content="Site ligado ao princiapl da Fundação COPEL, um portal direcionado aos beneficiários e contribuintes do fundo de aposentadoria complementar da Fundação COPEL." />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/prestador.jpg'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>COPEL Prestador</h1>
                            <Flexmidbanner>
                                <a href="https://prestador.fcopel.org.br" target="_blank" rel="noreferrer">prestador.fcopel.org.br</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//FRONT-END + INTEGRAÇÃO + WORDPRESS</Tags>
                            <Paragrafoint>Site ligado ao princiapl da Fundação COPEL, um portal direcionado aos beneficiários e contribuintes do fundo de aposentadoria complementar da Fundação COPEL.</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/prestadorpag.png" alt="Home do site" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Fui responsável pela criação do site com foco no uso interno dos contribuintes e associados da Fundação COPEL, funcionando como uma "área privada" exclusiva. O projeto foi desenvolvido utilizando HTML, CSS, JavaScript e PHP, e também integrei o WordPress como CMS para facilitar a administração de conteúdo e permitir que os usuários realizem atualizações de forma simples.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/prestadorinside.png" alt="Página Interna - Fcopel" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>O site oferece uma série de funcionalidades essenciais, como um sistema de chat ao vivo para facilitar a comunicação em tempo real, além de permitir a consulta e download de documentos, o que otimiza a gestão interna. O projeto foi desenvolvido para incorporar recursos adicionais que melhoram a interação entre os contribuintes e a empresa. Hoje, o site continua sendo mantido e atualizado com novas funcionalidades, com o objetivo de proporcionar uma experiência mais fluida e moderna para os usuários.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/energisaprev" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>EnergisaPrev</h3>
                                <span>//FRONT-END + WORDPRESS</span>
                            </Btnnav>
                        </Link>

                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/energisaprev" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/elosprev" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/elosprev" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>ELOS Previdência</h3>
                                <span>//FRONT-END + RESTRUTURAÇÃO UX/UI</span>
                            </Btnnav>
                        </Link>
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default Prestador;